export const initNavigation = () => {
    const toggle = document.getElementById('sidebarToggle');
    const sidebar = document.getElementById('appSidebar');
    const overlay = document.getElementById('sidebarOverlay');

    if (!toggle || !sidebar) return;

    // Function to open/close
    const toggleMenu = (e) => {
        if (e) e.preventDefault();
        sidebar.classList.toggle('is-active');
        if (overlay) overlay.classList.toggle('is-active');
        
        // Lock body scroll when menu is open (native app feel)
        if (sidebar.classList.contains('is-active')) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    };

    toggle.addEventListener('click', toggleMenu);

    // Close when clicking the overlay (dark area)
    if (overlay) {
        overlay.addEventListener('click', toggleMenu);
    }

};
